export const textButton = {
	order: 'Pre-order',
	buy: 'Buy',
	learnMore: 'Learn More',
};

export const sectionTitle = {
	title1: 'Which iPhone is right for you?',
	title2: 'Which MacBook is right for you?',
	title3: 'Which iPad is right for you?',
};

export const productsInfo = [
	{
		id: 1,
		title: 'iPhone 14 Pro',
		category: 'Phone-Order',
		description: 'The ultimate iPhone.',
		displaySize: '6.7" or 6.1"',
		displayType: 'Super Retina XDR display. ProMotion technology. Always-On display',
		cameraSystem: 'Pro camera system',
		cameraType: '48Mp Main | Ultra Wide | Telephoto Autofocus on TrueDepth front camera',
		battery: 'Up to 23 hours video playback',
		chipset: 'A16 Bionic 6-core GPU',
		recognition: 'Face ID',
		network: 'Superfast 5G cellular e-sim',
		price: 999,
		condition: 'New',
		img: '../images/iphone-14-pro.png',
		imgModal: '../images/iphone14-modal.jpg',
		cameraImg: '../images/icon-pro-camera.png',
		batteryImg: '../images/icon-battery.png',
		chipsetImg: '../images/icon-A16chip.png',
		recognitionImg: '../images/icon-faceid.png',
		networkImg: '../images/icon-5g.png',
	},
	{
		id: 2,
		title: 'iPhone 14',
		category: 'Phone',
		description: 'A total powerhouse.',
		displaySize: '6.7" or 6.1"',
		displayType: 'Super Retina XDR display',
		cameraSystem: 'Advanced dual-camera system',
		cameraType: '12Mp Main | Ultra Wide Autofocus on TrueDepth front camera',
		battery: 'Up to 20 hours video playback',
		chipset: 'A15 Bionic 6-core GPU',
		recognition: 'Face ID',
		network: 'Superfast 5G cellular e-sim',
		price: 799,
		condition: 'New',
		img: '../images/iphone-14.png',
		imgModal: '../images/iphone14-modal.jpg',
		cameraImg: '../images/icon-dual-lens.png',
		batteryImg: '../images/icon-battery.png',
		chipsetImg: '../images/icon-A15chip.png',
		recognitionImg: '../images/icon-faceid.png',
		networkImg: '../images/icon-5g.png',
	},
	{
		id: 3,
		title: 'iPhone 13',
		category: 'Phone',
		description: 'As amazing as ever.',
		displaySize: '6.1" or 5.4"',
		displayType: 'Super Retina XDR display',
		cameraSystem: 'Dual-camera system',
		cameraType: '12Mp Main | Ultra Wide TrueDepth front camera',
		battery: 'Up to 19 hours video playback',
		chipset: 'A15 Bionic 4-core GPU',
		recognition: 'Face ID',
		network: 'Superfast 5G cellular',
		price: 599,
		condition: '⠀',
		img: '../images/iphone-13-pro.png',
		imgModal: '../images/iphone13-modal.jpg',
		cameraImg: '../images/icon-dual-lens.png',
		batteryImg: '../images/icon-battery.png',
		chipsetImg: '../images/icon-A15chip.png',
		recognitionImg: '../images/icon-faceid.png',
		networkImg: '../images/icon-5g.png',
	},
	{
		id: 4,
		title: 'iPhone 12',
		category: 'Phone',
		description: 'Perfect balance.',
		displaySize: '6.1"',
		displayType: 'Super Retina XDR display',
		cameraSystem: 'Dual-camera system',
		cameraType: '12Mp Main | Ultra Wide TrueDepth front camera',
		battery: 'Up to 17 hours video playback',
		chipset: 'A14 Bionic 4-core GPU',
		recognition: 'Face ID',
		network: 'Superfast 5G cellular',
		price: 599,
		condition: '⠀',
		img: '../images/iphone-12.png',
		imgModal: '../images/iphone12-modal.jpg',
		cameraImg: '../images/icon-dual-lens.png',
		batteryImg: '../images/icon-battery.png',
		chipsetImg: '../images/icon-A14chip.png',
		recognitionImg: '../images/icon-faceid.png',
		networkImg: '../images/icon-5g.png',
	},
	{
		id: 5,
		title: 'Iphone SE',
		category: 'Phone',
		description: 'Serious power. Serious value.',
		displaySize: '4.7"',
		displayType: 'Retina HD display',
		cameraSystem: 'Single camera',
		cameraType: '12Mp Main Front camera',
		battery: 'Up to 13 hours video playback',
		chipset: 'A13 Bionic 4-core GPU',
		recognition: 'Touch ID',
		network: '4G LTE cellular',
		price: 429,
		condition: '⠀',
		img: '../images/iphone-se.png',
		imgModal: '../images/iphoneSE-modal.jpg',
		cameraImg: '../images/icon-single-camera.png',
		batteryImg: '../images/icon-battery.png',
		chipsetImg: '../images/icon-A13chip.png',
		recognitionImg: '../images/icon-touchid.png',
		networkImg: '../images/icon-4g.png',
	},
	{
		id: 6,
		title: 'MacBook 16 Pro',
		category: 'Computer',
		description: 'Supercharged for pros.',
		displaySize: '16.2""',
		displayType: 'Liquid Retina XDR display',
		chipset: 'Apple M1 Pro chip',
		cpu: '10 core',
		gpu: '32 core',
		ram: '64 GB',
		storage: '8 TB',
		battery: '21 hours battery life',
		recognition: 'Touch ID',
		price: 2499,
		condition: 'New',
		img: '../images/macbook-pro-16.png',
		imgModal: '../images/macbook-pro-16.png',
		batteryImg: '../images/icon-battery.png',
		chipsetImg: '../images/icon-m1-pro.png',
		recognitionImg: '../images/icon-touchid.png',
	},
	{
		id: 7,
		title: 'MacBook 13 Pro',
		category: 'Computer',
		description: 'Pro anywhere.',
		displaySize: '13.3""',
		displayType: 'Retina display',
		chipset: 'Apple M2 chip',
		cpu: '8 core',
		gpu: '10 core',
		ram: '24 GB',
		storage: '2 TB',
		battery: '20 hours battery life',
		recognition: 'Touch Bar and Touch ID',
		price: 1299,
		condition: 'New',
		img: '../images/macbook-pro-13.png',
		imgModal: '../images/macbook-pro-13.png',
		batteryImg: '../images/icon-battery.png',
		chipsetImg: '../images/icon-m2.png',
		recognitionImg: '../images/icon-touchid.png',
	},
	{
		id: 8,
		title: 'MacBook Air',
		category: 'Computer',
		description: 'M2 Chip.',
		displaySize: '13.6""',
		displayType: 'Liquid Retina display',
		chipset: 'Apple M2 chip',
		cpu: '8 core',
		gpu: '10 core',
		ram: '24 GB',
		storage: '2 TB',
		battery: '18 hours battery life',
		recognition: 'Touch ID',
		price: 1199,
		condition: 'New',
		img: '../images/macbook-air-m2.png',
		imgModal: '../images/macbook-air-m2.png',
		batteryImg: '../images/icon-battery.png',
		chipsetImg: '../images/icon-m2.png',
		recognitionImg: '../images/icon-touchid.png',
	},
	{
		id: 9,
		title: 'MacBook Air',
		category: 'Computer',
		description: 'M1 Chip.',
		displaySize: '13.3""',
		displayType: 'Retina display',
		chipset: 'Apple M1 chip',
		cpu: '8 core',
		gpu: '7 core',
		ram: '16 GB',
		storage: '2 TB',
		battery: '18 hours battery life',
		recognition: 'Touch ID',
		price: 999,
		condition: '⠀',
		img: '../images/macbook-air-m1.png',
		imgModal: '../images/macbook-air-m1.png',
		batteryImg: '../images/icon-battery.png',
		chipsetImg: '../images/icon-m1.png',
		recognitionImg: '../images/icon-touchid.png',
	},
	{
		id: 10,
		title: 'Ipad Pro',
		category: 'Ipad',
		description: 'The ultimate iPad experience.',
		displaySize: '12.9""',
		displayType: 'Liquid Retina XDR display',
		cameraType: '12MP Wide and 10MP ultra Wide cameras',
		chipset: 'M1 chip with next-generation Neural Engine',
		storage: '2 TB',
		connector: 'USB-C connector with support for Thunderbolt / USB 4',
		network: '5G Superfast downloads and streaming',
		price: 1099,
		condition: '⠀',
		img: '../images/ipad-pro.png',
		imgModal: '../images/ipad_pro-modal.jpg',
		chipsetImg: '../images/icon-m1.png',
		cameraImg: '../images/icon-ipadpro-camera2.png',
		connectorImg: '../images/icon-usbc-thunderbolt.png',
		networkImg: '../images/icon-5g.png',
	},
	{
		id: 11,
		title: 'Ipad Air',
		category: 'Ipad',
		description: 'Powerfull. Colorfull.',
		displaySize: '10.9""',
		displayType: 'Liquid Retina display True Tone',
		cameraType: '12MP Wide camera',
		chipset: 'M1 chip with next-generation Neural Engine',
		storage: '256 GB',
		connector: 'USB-C connector',
		network: '5G Superfast downloads and streaming',
		price: 599,
		condition: 'New',
		img: '../images/ipad-air.png',
		imgModal: '../images/ipad_air-modal.jpg',
		chipsetImg: '../images/icon-m1.png',
		cameraImg: '../images/icon-ipad-air-camera.png',
		connectorImg: '../images/icon-usbc.png',
		networkImg: '../images/icon-5g.png',
	},
	{
		id: 12,
		title: 'Ipad',
		category: 'Ipad',
		description: 'Delightfully capable.',
		displaySize: '10.2""',
		displayType: 'Retina display True Tone',
		cameraType: '8MP Wide camera',
		chipset: 'A13 Bionic Chip with Neural Engine',
		storage: '256 GB',
		connector: 'Lightning connector',
		network: '4G LTE cellular',
		price: 329,
		condition: 'New',
		img: '../images/ipad.png',
		imgModal: '../images/ipad-modal.jpg',
		chipsetImg: '../images/icon-A13chip.png',
		cameraImg: '../images/icon-ipad-air-camera.png',
		connectorImg: '../images/icon-lightning.png',
		networkImg: '../images/icon-4g.png',
	},
	{
		id: 13,
		title: 'Ipad Mini',
		category: 'Ipad',
		description: 'Mega power. Mini sized.',
		displaySize: '8.3"',
		displayType: 'Liquid Retina display True Tone',
		cameraType: '12MP Wide camera',
		chipset: 'A15 Bionic Chip with Neural Engine',
		storage: '256 GB',
		connector: 'USB-C connector',
		network: '5G Superfast downloads and streaming',
		price: 499,
		condition: '⠀',
		img: '../images/ipad-mini.png',
		imgModal: '../images/ipad_mini-modal.jpg',
		chipsetImg: '../images/icon-A15chip.png',
		cameraImg: '../images/icon-ipad-air-camera.png',
		connectorImg: '../images/icon-usbc.png',
		networkImg: '../images/icon-5g.png',
	},
];

export const aboutUs = [
	{
		id: 1,
		image: '../images/us/ad.jpg',
		nombre: 'Alejandro Di Tullio',
		linkedIn: 'https://www.linkedin.com/in/alejandro-di-tullio-70384815',
		github: 'https://github.com/ditullioale',
	},
	{
		id: 2,
		image: '../images/us/bg.jpg',
		nombre: 'Bruno Ghiotti',
		linkedIn: 'https://www.linkedin.com/in/bruno-ghiotti-2a16b21a0',
		github: 'https://github.com/BrunoGhi',
	},
	{
		id: 3,
		image: '../images/us/cg.jpg',
		nombre: 'Cristian Gili',
		linkedIn: 'https://www.linkedin.com/in/cristian-gili-8a9a26160',
		github: 'https://github.com/cristiangili',
	},
	{
		id: 4,
		image: '../images/us/lc.jpg',
		nombre: 'Leandro Castagno',
		linkedIn: 'https://www.linkedin.com/in/leandro-castagno-03b563218',
		github: 'https://github.com/LDC-ar',
	},
	{
		id: 5,
		image: '../images/us/gh.jpg',
		nombre: 'Lucas Cardellino',
		linkedIn: 'https://www.linkedin.com/in/lcardellino',
		github: 'https://github.com/lcardellino',
	},
	{
		id: 7,
		image: '../images/us/np.jpg',
		nombre: 'Natalia Pogonza',
		linkedIn: 'https://www.linkedin.com/in/natalia-pogonza-31b90018a',
		github: 'https://github.com/Naty5585',
	},
	{
		id: 8,
		image: '../images/us/sc.jpg',
		nombre: 'Sergio Cardozo',
		linkedIn: 'https://www.linkedin.com/in/sergio-ezequiel-cardozo-a71054235',
		github: 'https://github.com/sergiocardozofs',
	},
];

export const SliderData = [
	{
		image: '../images/tv-central-park.jpg',
		id: 1,
	},
	{
		image: '../images/tv-black-bird.jpg',
		id: 2,
	},
	{
		image: '../images/tv-five-days-at-memorial.jpg',
		id: 3,
	},
	{
		image: '../images/tv-gutsy.jpg',
		id: 4,
	},
	{
		image: '../images/tv-life-by-ella.jpg',
		id: 5,
	},
	{
		image: '../images/tv-luck.jpg',
		id: 6,
	},
	{
		image: '../images/tv-see.jpg',
		id: 7,
	},
	{
		image: '../images/tv-severance.jpg',
		id: 8,
	},
	{
		image: '../images/tv-friday-night-baseball.jpg',
		id: 9,
	},
];

export const SliderDataMobile = [
	{
		image: '../images/mobile-baseball.jpg',
		id: 1,
	},
	{
		image: '../images/mobile-luck.jpg',
		id: 2,
	},
	{
		image: '../images/mobile-central.jpg',
		id: 3,
	},
	{
		image: '../images/mobile-see.jpg',
		id: 4,
	},
	{
		image: '../images/mobile-five.jpg',
		id: 5,
	},
	{
		image: '../images/mobile-life.jpg',
		id: 6,
	},
	{
		image: '../images/mobile-black.jpg',
		id: 7,
	},
	{
		image: '../images/mobile-sever.jpg',
		id: 8,
	},
	{
		image: '../images/mobile-gutsy.jpg',
		id: 9,
	},
];
